export default "__VITE_ASSET__D$Xo$4d1__"